<template>
  <ElInputWrapper>
    <FlexLayout :align="flexLayout.align" :gap="flexLayout.gap" :col="flexLayout.col">
      <component
        :is="filter.component"
        v-for="(filter, index) in filters"
        :key="index"
        v-bind="typeof filter.props === 'function' ? filter.props(syncModels) : filter.props"
        v-model="syncModels[filter.key]"
        v-on="typeof filter.on === 'function' ? filter.on(syncModels) : filter.on"
      >
        <template v-if="filter.slot">
          <slot :name="filter.slot">
            <component
              :is="filter.slot"
              v-bind="filter.slot?.props"
              v-on="filter.slot?.on"
            />
          </slot>
        </template>
      </component>
    </FlexLayout>
  </ElInputWrapper>
</template>

<script>
import { useVModel } from '@vueuse/core'
import { defineComponent } from 'vue'
import ElInputWrapper from './ElInputWrapper.vue'
export default defineComponent({
  name: 'StructureFilters',
  components: {
    ElInputWrapper,
  },
  props: {
    flexLayout: {
      type: Object,
      default: () => {
        return {
          align: 'center',
          gap: '12px',
        }
      },
    },
    filters: {
      type: Array,
      default: () => [
        // {
        //   component: 'BaseElInput',
        //   key: 'name',
        //   mode: 'equals',
        //   props: {
        //     placeholder: '請輸入名稱',
        //   },
        // },
      ],
    },
    models: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const syncModels = useVModel(props, 'models', emit)
    return {
      syncModels,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
